import React from 'react';
import { any, oneOf } from 'prop-types';
import bem from '../../utils/bem';

export const GROUP_TYPE = {
    price: 'price',
    title: 'title',
};

const SubInfoItemGroup = ({ groupType, title, subTitle, isLoading, className = '', onClick = () => {} }) => {
    return (
        <div className={`${className} ` + bem('subinfo-item__group', [groupType])} >
            {isLoading ? (
                null
            ): (
                <>
                    <span onClick={onClick} role="button" className="subinfo-item__group-title">{title}</span>
                    {subTitle && <span className="subinfo-item__group-subtitle">{subTitle}</span>}
                </>
            )}
            
        </div>
    );
};

SubInfoItemGroup.defaultProps = {
    groupType: GROUP_TYPE.title
};

SubInfoItemGroup.propTypes = {
    groupType: oneOf(Object.keys(GROUP_TYPE)),
    title: any,
    subTitle: any
};

export default SubInfoItemGroup
